<template>
  <div class="listContent">
    <div
      class="itemCont"
      v-for="(item, key) in goodsList"
      :key="key"
      @click="choseGoods(item)"
    >
      <div class="status_ico status_success" v-show="isClickNode(item)">
        <i class="el-icon-check" />
      </div>
      <div class="itemImg">
        <img
          :src="item.image || avater"
          alt=""
          style="width: 168px; height: 168px; padding: 15px 0px"
        />
      </div>
      <el-tooltip
        class="item"
        effect="dark"
        :content="item.goodsSkuTitle"
        placement="top"
      >
        <div class="itemBox name text-ellipsis">
          <!-- 商品名称 -->
          {{ item.goodsSkuTitle || "-" }}
        </div>
      </el-tooltip>
      <div v-if="item.goodsFactory" class="itemBox factory text-ellipsis">
        <!-- 生产厂家 -->
        {{ item.goodsFactory || "-" }}
      </div>
      <div v-if="item.approvalNumber" class="itemBox factory">
        <!-- 国药准字 -->
        {{ item.approvalNumber || "-" }}
      </div>
      <div
        v-if="item.specification"
        class="itemBox factory"
        style="padding-bottom: 10px"
      >
        <!-- 规格 -->
        {{ item.specification || "-" }}
      </div>
      <div class="itemBox factory text-ellipsis">
        30日销售额：{{ item.thirtyDaysSales || "-" }}
      </div>
    </div>
  </div>
</template>

<script>
import avater from "/public/img/default.png";
export default {
  props: {
    // 商品列表
    goodsList: {
      type: Array,
      default: () => [],
    },
    // 已选的商品列表IDS
    chooseGoodsIds: {
      type: Array,
      default: () => [],
    },
    goodsKey: {
      type: String,
      default: "goodsId",
    },
  },
  computed: {},
  data() {
    return {
      avater,
      loading: false,
    };
  },
  watch: {},
  mounted() {},
  methods: {
    // 展示勾选图标
    isClickNode(item) {
      return this.chooseGoodsIds.some((id) => id === item[this.goodsKey]);
    },
    // 选择商品
    choseGoods(item) {
      this.$emit("chooseItem", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.listContent {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 50vh;
  justify-content: flex-start;
  overflow: auto;

  .goodList {
    width: calc(50% - 10px);
    display: flex;
    justify-content: space-around;
    margin: 5px;
    padding: 10px;

    &:nth-child(3n) {
      margin-right: 0px;
    }

    .img-div {
      height: 88px;
      width: 88px;
      margin: 0 10px;

      image {
        width: 100%;
        height: 100%;
      }
    }

    .l {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      object-fit: cover;
    }

    .r {
      width: 214px;
      display: flex;
      flex: 1;
      flex-direction: column;

      div {
        display: flex;
      }

      span {
        font-size: 13px;
        color: #333;
        //margin-top: 10px;
      }

      .name {
        text-align: left;
        font-size: 16px;
        font-weight: 600;
        color: var(--color-26);
      }

      .rr {
        text-align: left;
        color: var(--color-59);
        font-size: 14px;
      }
    }

    &:hover {
      //  border: 2px solid var(--main-color) !important;
    }
  }

  .actived {
    border: 2px solid var(--main-color) !important;
  }

  .activeIcon {
    font-size: 40px;
    position: absolute;
    color: var(--main-color);
    right: -10px;
    top: -10px;
    z-index: 6;
  }
}

.goodList-b {
  border: solid 1px #f5222d;
  border-radius: 5px;
}

::v-deep .el-table__header {
  .el-checkbox {
    display: none;
  }
}

.itemCont {
  position: relative;
  width: 15.6%;
  overflow: hidden;
  //  min-width: 225px;
  // height: 300px;
  border: 1px solid #dcdfe6;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 4px;

  .status_ico {
    position: absolute;
    right: -15px;
    top: -6px;
    width: 40px;
    height: 24px;
    background: #13ce66;
    text-align: center;
    transform: rotate(45deg);
    box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
    display: block;
    cursor: pointer;

    .el-icon-check {
      font-size: 12px;
      margin-top: 11px;
      transform: rotate(-45deg);
      color: #fff;
    }

    .el-icon-close {
      font-weight: 700;
      color: white;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .status_error {
    background: red;
  }

  .name {
    font-size: 16px;
    font-weight: 600;
  }

  .factory {
    color: #595959;
    font-size: 14px;
  }

  .itemBox {
    padding: 3px 10px;
    display: flex;
    justify-content: flex-start;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }

  .itemImg {
    height: 168px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .price {
    font-weight: 700;
    justify-content: end;
  }

  .shopCar {
    margin-top: 20px;
    justify-content: center;
  }
}

.text-ellipsis {
  display: -webkit-box !important;
  line-height: 24px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-ellipsis-2 {
  display: -webkit-box !important;
  line-height: 24px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
